import { render, staticRenderFns } from "./flow.vue?vue&type=template&id=666322ca&scoped=true&"
var script = {}
import style0 from "./flow.vue?vue&type=style&index=0&id=666322ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666322ca",
  null
  
)

export default component.exports